import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Corriere} from "../Models/Corriere";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import { ApiRestService } from '../_services/api-rest.service';
import {ClassicType} from "../../shared/models/ClassicType";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-corriere-edit',
  templateUrl: './corriere-edit.component.html',
  styleUrls: ['./corriere-edit.component.css']
})
export class CorriereEditComponent implements OnInit {
  @Input() Item: Corriere = new Corriere();
  @Output() updated = new EventEmitter<Corriere>();
  @Input() IsModal: boolean = true;
  dropdownSettings:IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'label'
  };
  Tipi: ClassicType[] = [];
  constructor (
    public ngbActiveModal: NgbActiveModal,
    private ApiRestService: ApiRestService,
    private toastService: ToastrService,
  ) { }

  ngOnInit(): void {
    this.ApiRestService.TipiCorriere().subscribe(data=> this.Tipi = data )
  }

  Save() {
    if(!this.Item) return;
    this.Item.tipi = this.Item.tipiObject?.map(x=> parseInt(x.id?.toString())) ?? [];
    if (this.Item.id)
      this.ApiRestService.UpdateCorriere(this.Item).subscribe(() => {
        this.updated.emit(this.Item);
        this.ngbActiveModal.dismiss()
      });
    else if(this.Item.nominativo)
      this.ApiRestService.AddCorriere(this.Item).subscribe((data) => {
        this.updated.emit(data);
        this.ngbActiveModal.dismiss()
      });
    else
      this.toastService.warning("inserire i campi richiesti", "Attenzione!!");
  }
  close(){
    this.updated.emit();
    this.ngbActiveModal.dismiss()
  }
}
